import { render } from "./AuctionView.vue?vue&type=template&id=c23d2a7a&scoped=true"
import script from "./AuctionView.vue?vue&type=script&lang=js"
export * from "./AuctionView.vue?vue&type=script&lang=js"

import "./AuctionView.vue?vue&type=style&index=0&id=c23d2a7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c23d2a7a"]])

export default __exports__